"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_parser_1 = require("@dynamynd/content-parser");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.ScaleQuestionOption = function (_a) {
  var onPress = _a.onPress,
      text = _a.text,
      textColor = _a.textColor,
      selectedCircle = _a.selectedCircle,
      backgroundColor = _a.backgroundColor,
      disabled = _a.disabled,
      activeBreakpoint = _a.activeBreakpoint,
      accessabilityLabel = _a.accessabilityLabel;
  return react_1.default.createElement(ScaleButtonContainer, {
    onPress: onPress,
    activeBreakpoint: activeBreakpoint,
    backgroundColor: backgroundColor,
    disabled: disabled,
    accessibilityLabel: accessabilityLabel
  }, react_1.default.createElement(ButtonText, {
    textColor: textColor
  }, react_1.default.createElement(content_parser_1.ParsedContent, {
    content: text
  })), react_1.default.createElement(CircleActive, null, selectedCircle && react_1.default.createElement(exports.SelectedScaleOption, null)));
};

var ScaleButtonContainer = styled_components_1.default(react_native_1.TouchableOpacity)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 30px;\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);\n    align-items: center;\n    ", "\n"], ["\n    flex-direction: row;\n    justify-content: space-between;\n    margin-bottom: 30px;\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);\n    align-items: center;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      backgroundColor = _a.backgroundColor,
      theme = _a.theme;
  var small = responsive_1.isSmall(activeBreakpoint);
  var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
  return "\n            margin: " + (small ? '5px' : '10px') + ";\n            height: " + (!extraLarge ? '45px' : '62px') + ";\n            width: " + (!extraLarge ? '98%' : '138px') + ";\n            background-color: " + (backgroundColor ? backgroundColor : theme.backgroundColor.whiteButton) + ";\n        ";
});
var ButtonText = styled_components_1.default(function (_a) {
  var textColor = _a.textColor,
      rest = __rest(_a, ["textColor"]);

  return react_1.default.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 18px;\n    margin-right: 5px;\n    font-weight: 500;\n    font-family: Roboto;\n    line-height: 30px;\n    color: ", ";\n"], ["\n    font-size: 18px;\n    margin-right: 5px;\n    font-weight: 500;\n    font-family: Roboto;\n    line-height: 30px;\n    color: ", ";\n"])), function (_a) {
  var textColor = _a.textColor,
      theme = _a.theme;
  return textColor ? textColor : theme.colors.buttonText;
});
var CircleActive = styled_components_1.default(react_native_1.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 17px;\n    width: 17px;\n    border: 1px solid #dd7d38;\n    border-radius: 10px;\n    background-color: #fff;\n"], ["\n    height: 17px;\n    width: 17px;\n    border: 1px solid #dd7d38;\n    border-radius: 10px;\n    background-color: #fff;\n"])));
exports.SelectedScaleOption = styled_components_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 7px;\n    height: 7px;\n    margin: 4px;\n    border-radius: 6px;\n    background-color: #dd7d38;\n    font-family: Roboto;\n"], ["\n    width: 7px;\n    height: 7px;\n    margin: 4px;\n    border-radius: 6px;\n    background-color: #dd7d38;\n    font-family: Roboto;\n"])));
exports.default = responsive_1.withResponsiveMeta(exports.ScaleQuestionOption);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;